// removed by extract-text-webpack-plugin
module.exports = {"main":"LoadPage-main","spinner":"LoadPage-spinner","linkWrap":"LoadPage-linkWrap","link":"LoadPage-link","header":"LoadPage-header","covered":"LoadPage-covered","coveredIcon":"LoadPage-coveredIcon","coveredTitle":"LoadPage-coveredTitle","coverDesc":"LoadPage-coverDesc","coverButton":"LoadPage-coverButton","premium":"LoadPage-premium","premiumTitle":"LoadPage-premiumTitle","premiumContent":"LoadPage-premiumContent","premiumDesc":"LoadPage-premiumDesc","premiumIcon":"LoadPage-premiumIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadPage/index.css
// module id = 1716
// module chunks = 0